!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/wordcount"] = t() : (e.wp = e.wp || {}, e.wp.wordcount = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      864: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.defaultSettings = void 0;
        var r = {
          HTMLRegExp: /<\/?[a-z][^>]*?>/gi,
          HTMLcommentRegExp: /<!--[\s\S]*?-->/g,
          spaceRegExp: /&nbsp;|&#160;/gi,
          HTMLEntityRegExp: /&\S+?;/g,
          connectorRegExp: /--|\u2014/g,
          removeRegExp: new RegExp(["[", "!-/:-@[-`{-~", "-¿×÷", " -⯿", "⸀-⹿", "]"].join(""), "g"),
          astralRegExp: /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
          wordsRegExp: /\S\s+/g,
          characters_excluding_spacesRegExp: /\S/g,
          characters_including_spacesRegExp: /[^\f\n\r\t\v\u00AD\u2028\u2029]/g,
          l10n: {
            type: "words"
          }
        };
        t.defaultSettings = r;
      },
      149: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripConnectors(e, t) {
          return t.replace(e.connectorRegExp, " ");
        };
      },
      966: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripHTMLComments(e, t) {
          return t.replace(e.HTMLcommentRegExp, "");
        };
      },
      602: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripHTMLEntities(e, t) {
          return t.replace(e.HTMLEntityRegExp, "");
        };
      },
      664: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripRemovables(e, t) {
          return t.replace(e.removeRegExp, "");
        };
      },
      140: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripShortcodes(e, t) {
          if (e.shortcodesRegExp) return t.replace(e.shortcodesRegExp, "\n");
          return t;
        };
      },
      817: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripSpaces(e, t) {
          return t.replace(e.spaceRegExp, " ");
        };
      },
      733: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function stripTags(e, t) {
          return t.replace(e.HTMLRegExp, "\n");
        };
      },
      194: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function transposeAstralsToCountableChar(e, t) {
          return t.replace(e.astralRegExp, "a");
        };
      },
      294: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function transposeHTMLEntitiesToCountableChars(e, t) {
          return t.replace(e.HTMLEntityRegExp, "a");
        };
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var u = t[r] = {
        exports: {}
      };
      return e[r](u, u.exports, __webpack_require__), u.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.count = function count(e, t, r) {
        var o = function loadSettings(e, t) {
          var r, s;
          var o = (0, n.extend)({}, u.defaultSettings, t);
          o.shortcodes = null !== (r = null === (s = o.l10n) || void 0 === s ? void 0 : s.shortcodes) && void 0 !== r ? r : [], o.shortcodes && o.shortcodes.length && (o.shortcodesRegExp = new RegExp("\\[\\/?(?:" + o.shortcodes.join("|") + ")[^\\]]*?\\]", "g"));
          o.type = e, "characters_excluding_spaces" !== o.type && "characters_including_spaces" !== o.type && (o.type = "words");
          return o;
        }(t, r);

        var p;

        switch (o.type) {
          case "words":
            return p = o.wordsRegExp, function countWords(e, t, r) {
              var u, o;
              return e = (0, n.flow)(s.default.bind(null, r), i.default.bind(null, r), _.default.bind(null, r), d.default.bind(null, r), c.default.bind(null, r), a.default.bind(null, r), l.default.bind(null, r))(e), null !== (u = null === (o = (e += "\n").match(t)) || void 0 === o ? void 0 : o.length) && void 0 !== u ? u : 0;
            }(e, p, o);

          case "characters_including_spaces":
            return p = o.characters_including_spacesRegExp, countCharacters(e, p, o);

          case "characters_excluding_spaces":
            return p = o.characters_excluding_spacesRegExp, countCharacters(e, p, o);

          default:
            return 0;
        }
      };

      var n = __webpack_require__(793),
          u = __webpack_require__(864),
          s = t(__webpack_require__(733)),
          o = t(__webpack_require__(194)),
          c = t(__webpack_require__(602)),
          a = t(__webpack_require__(149)),
          l = t(__webpack_require__(664)),
          i = t(__webpack_require__(966)),
          _ = t(__webpack_require__(140)),
          d = t(__webpack_require__(817)),
          p = t(__webpack_require__(294));

      function countCharacters(e, t, r) {
        var u, c;
        return e = (0, n.flow)(s.default.bind(null, r), i.default.bind(null, r), _.default.bind(null, r), o.default.bind(null, r), d.default.bind(null, r), p.default.bind(null, r))(e), null !== (u = null === (c = (e += "\n").match(t)) || void 0 === c ? void 0 : c.length) && void 0 !== u ? u : 0;
      }
    }(), r;
  }();
});